import {
  SET_SIGNUP_PREFILLED,
  SET_LOGIN_PREFILLED,
  CLEAR_INVITE_PREFILLED,
  LOAD_CAMPAIGN_INVITE,
} from './constants';

export function setSignupPrefilled(shortId, name, email) {
  return {
    type: SET_SIGNUP_PREFILLED,
    shortId,
    name,
    email,
  };
}

export function setLoginPrefilled(email) {
  return {
    type: SET_LOGIN_PREFILLED,
    email,
  };
}

export function clearInvitePrefilled() {
  return {
    type: CLEAR_INVITE_PREFILLED,
  };
}

export function loadCampaignInvite(data) {
  return {
    type: LOAD_CAMPAIGN_INVITE,
    data,
  };
}



/** WEBPACK FOOTER **
 ** ./src/containers/campaign-invite/actions.js
 **/